export class ResidentGlobalSearchResultDetail {
  fullName?: string;
  email?: string;
}

export class ResidentGlobalSearchResult {
  invited: ResidentGlobalSearchResultDetail[] = [];
  application: ResidentGlobalSearchResultDetail[] = [];
  active: ResidentGlobalSearchResultDetail[] = [];
  leaseEnded: ResidentGlobalSearchResultDetail[] = [];
  completed: ResidentGlobalSearchResultDetail[] = [];
  claims: ResidentGlobalSearchResultDetail[] = [];
}
